type Lit = string | number | boolean | undefined | null | void | {};
export const Tuple = <T extends Lit[]>(...args: T) => args;
